import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="w-full py-32 px-6 bg-[#0D0D0D] relative overflow-hidden" data-id="element-88">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#D4A853]/10 via-transparent to-transparent opacity-50 pointer-events-none" data-id="element-89" />

      <div className="max-w-2xl w-full mx-auto text-center space-y-12 relative z-10" data-id="element-90">
        {/* Label */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-91">
          <span className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium border border-[#D4A853]/30 px-4 py-2 rounded-full" data-id="element-92">
            La Oferta
          </span>
        </motion.div>

        {/* Intro Text */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-[#F5F0E8] font-serif leading-relaxed" data-id="element-93">
          No necesitas pagar miles en coaching. El mapa exacto para recuperar tu
          vida hoy mismo está aquí.
        </motion.p>

        {/* CTA Button above offer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="flex justify-center" data-id="element-94">
          <motion.a href="https://pay.hotmart.com/W104590595C" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart');
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} whileHover={{
          scale: 1.02,
          backgroundColor: '#E8BE6A'
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-[#D4A853] text-[#0D0D0D] font-bold text-lg px-8 py-4 rounded-lg shadow-lg transition-colors uppercase tracking-wide text-center" data-id="element-95">
            SÍ, QUIERO REINICIAR MI VIDA AHORA
          </motion.a>
        </motion.div>

        {/* Price & Value */}
        <div className="space-y-6" data-id="element-96">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col items-center justify-center bg-[#1A1A1A]/30 p-8 rounded-2xl border border-[#333]" data-id="element-97">
            <span className="text-[#A89F91] text-lg mb-2 uppercase tracking-widest text-xs" data-id="element-98">
              Consigue «Reinicio Total 35+» hoy por solo:
            </span>
            <div className="flex items-baseline gap-4 justify-center" data-id="element-99">
              <span className="md:text-5xl font-serif text-[#A89F91]/40 line-through font-bold text-[24px]" data-id="element-100">
                $29
              </span>
              <span className="md:text-8xl font-serif text-[#D4A853] font-bold tracking-tight text-[24px]" data-id="element-101">
                $6.39{' '}
                <span className="text-2xl text-[#D4A853]/60 font-normal" data-id="element-102">
                  USD
                </span>
              </span>
            </div>
            <span className="inline-block mt-3 bg-[#D4A853]/15 text-[#D4A853] text-sm font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-103">
              78% de descuento
            </span>
            <span className="text-[#A89F91] text-sm mt-4 block" data-id="element-104">
              (Pago único. Acceso inmediato).
            </span>
          </motion.div>
        </div>

        {/* Benefits List */}
        <motion.ul initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="space-y-4 text-left max-w-md mx-auto p-4" data-id="element-105">
          <li className="flex items-start gap-3" data-id="element-106">
            <Check className="w-5 h-5 text-[#D4A853] mt-1 shrink-0" data-id="element-107" />
            <span className="text-[#A89F91]" data-id="element-108">Sin rutinas imposibles.</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-109">
            <Check className="w-5 h-5 text-[#D4A853] mt-1 shrink-0" data-id="element-110" />
            <span className="text-[#A89F91]" data-id="element-111">Sin teoría barata.</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-112">
            <Check className="w-5 h-5 text-[#D4A853] mt-1 shrink-0" data-id="element-113" />
            <span className="text-[#A89F91]" data-id="element-114">
              Solo acciones de 15 minutos que devuelven el mando de tu vida a
              tus manos.
            </span>
          </li>
        </motion.ul>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="pt-4" data-id="element-115">
          <p className="mt-6 text-sm text-[#F5F0E8]/80" data-id="element-116">
            Haz clic para descargar tu guía y empezar hoy mismo.
          </p>

          <p className="mt-2 text-xs text-[#A89F91]/60 uppercase tracking-wider" data-id="element-117">
            Descarga inmediata · Acceso de por vida · Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}